import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import Methode from "@/pages/Methode";
import Projet from "@/pages/Projet";
import ProjetAgricole from "@/pages/ProjetAgricole";
import ProjetEquestre from "@/pages/ProjetEquestre";
import Blog from "@/pages/Blog";
import ComingSoon from "@/pages/ComingSoon";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

function Layout() {
    const { pathname } = useLocation();
    const hideFooter = pathname === "/projet";
    return (
        <>
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/methode" element={<Methode />} />
                <Route path="/projet" element={<Projet />} />
                <Route path="/projet/agricole" element={<ProjetAgricole />} />
                <Route path="/projet/equestre" element={<ProjetEquestre />} />
                <Route path="/blog" element={<Blog />} />
                <Route
                    path="/mentions-legales"
                    element={
                        <ComingSoon
                            title="Mentions légales"
                            subtitle="Les mentions légales de ROZIER CONCEPT seront publiées ici prochainement."
                        />
                    }
                />
                <Route
                    path="/politique-confidentialite"
                    element={
                        <ComingSoon
                            title="Politique de confidentialité"
                            subtitle="Notre politique de confidentialité sera publiée ici prochainement."
                        />
                    }
                />
                <Route
                    path="*"
                    element={
                        <ComingSoon
                            title="Page introuvable"
                            subtitle="La page que vous recherchez n'existe pas ou a été déplacée."
                        />
                    }
                />
            </Routes>
            {!hideFooter && <Footer />}
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Layout />
            </BrowserRouter>
        </div>
    );
}

export default App;
